import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import "./Contact.css";

const ContactSection = () => {
  return (
    <section id="contact" className="section fade-in">
      <div className="sectionContent">
        <h2>Contactez-moi</h2>
        <ul>
          <li>
            <FontAwesomeIcon icon={faPhone} /> Téléphone : <a href="tel:+33627701791">0627701791</a>
          </li>
          <li>
            <FontAwesomeIcon icon={faEnvelope} /> Email : <a href="mailto:trh.nicolas@gmail.com">trh.nicolas@gmail.com</a>
          </li>
          <li>
            <FontAwesomeIcon icon={faMapMarkerAlt} /> Zone d'intervention : Je travaille sur la commune d'Arles et dans les alentours.
          </li>
        </ul>
        <p>
          Les déplacements hors de cette zone sont soumis à un devis pour garantir la meilleure qualité de service.
        </p>
        <p>Pour toute demande d'information ou pour un devis, n'hésitez pas à me contacter :</p>
      </div>
    </section>
  );
};

export default ContactSection;
